import { Box, Text } from "@chakra-ui/react";
import { TEXT_VARIANTS } from "@/theme/components/text";
import { FOOTER_CONSTANTS } from "../footer.constants";

const FooterSocial = () => {
  return (
    <Box background="primary.200" color="white" p={4} width="full">
      <Text
        textAlign={"center"}
        variant={TEXT_VARIANTS.BODY3}
        color={"white"}
        px={10}
        style={{ lineHeight: "25px" }}
      >
        {FOOTER_CONSTANTS.RIGHTS}
      </Text>
    </Box>
  );
};

export default FooterSocial;
